module.exports = __webpack_public_path__ + "static/media/img108_R.ca9dac31.jpg";